<template>
  <v-app id="inspire">
    <gluid-app-toolbar />
    <gluid-editor />
  </v-app>
</template>

<script>
// @ is an alias to /src
// import the component and the necessary extensions
import GluidAppToolbar from "@/components/app/GluidAppToolbar";
import GluidEditor from "@/components/editor/GluidEditor";
import store from "@/store";
export default {
  beforeRouteUpdate(to, from, next) {
    try {
      store.dispatch("initializeApp", to.path);
    } catch (e) {
      console.log(e);
    }
    next();
  },
  components: {
    GluidAppToolbar,
    GluidEditor
  }
};
</script>
